import { streem } from 'streem-sdk-protobuf';
import { logger } from '../../util/logger';
import { Subject, merge, BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { recordToolPlaced } from '@streem/analytics';
import { debounce } from '../../util/debounce';
export class ToolsController {
    constructor(config) {
        this.config = config;
        this.toolStart = {
            LASER: undefined,
            MARKER: undefined,
        };
        this.debounceRecordToolPlaced = debounce((tool) => {
            const now = Date.now();
            const milliseconds = now - this.toolStart[tool];
            const eventProperties = {
                roomSid: this.config.context.roomId.toString(),
                [tool.toLowerCase()]: {
                    duration: {
                        seconds: Math.floor(milliseconds / 1000),
                        nanos: (milliseconds % 1000) * 1e6,
                    },
                },
            };
            recordToolPlaced(eventProperties);
            this.toolStart[tool] = undefined;
        }, 200);
        this._activeTool = new BehaviorSubject('LASER');
        this.activeTool = this._activeTool.asObservable();
        this.outgoingMessages = new Subject();
        const incomingMessages = this.config.mediaController.data.messages;
        const drawOutgoing = this.filterMessages(this.outgoingMessages, 'drawUpdate');
        const drawIncoming = this.filterMessages(incomingMessages, 'drawUpdate');
        const laserOutgoing = this.filterMessages(this.outgoingMessages, 'laserUpdate');
        const laserIncoming = this.filterMessages(incomingMessages, 'laserUpdate');
        this.drawMessages = merge(drawOutgoing, drawIncoming);
        this.laserMessages = merge(laserOutgoing, laserIncoming);
    }
    setActiveTool(tool) {
        this._activeTool.next(tool);
        logger.info('Tool chosen: ', tool);
    }
    updateTool(tool, eventType, coord) {
        const message = new streem.room.DataTrackMessage();
        if (eventType === streem.room.ToolEventType.TOOL_EVENT_TYPE_MOVE &&
            this.toolStart[tool] === undefined) {
            this.toolStart[tool] = Date.now();
            this.debounceRecordToolPlaced(tool);
        }
        else if (eventType === streem.room.ToolEventType.TOOL_EVENT_TYPE_MOVE &&
            this.toolStart[tool] !== undefined) {
            this.debounceRecordToolPlaced(tool);
        }
        switch (tool) {
            case 'LASER': {
                message.laserUpdate = new streem.room.LaserUpdate(this.buildPayload(eventType, coord));
                break;
            }
            case 'MARKER': {
                message.drawUpdate = new streem.room.DrawUpdate(this.buildPayload(eventType, coord));
                break;
            }
            default: {
                return;
            }
        }
        this.sendDataTrackMessage(message);
    }
    sendDataTrackMessage(message) {
        this.outgoingMessages.next(message);
        this.config.mediaController.data.send(message);
    }
    buildPayload(eventType, coord) {
        return Object.assign({ eventType }, coord && coord.xPercent !== undefined ? { xPercent: coord.xPercent } : null, coord && coord.yPercent !== undefined ? { yPercent: coord.yPercent } : null);
    }
    filterMessages(messageSource, type) {
        return messageSource.pipe(filter(msg => msg.type === type), map(msg => msg[type]));
    }
}
//# sourceMappingURL=tools_controller.js.map